import React from 'react'
import PropTypes from 'prop-types'
import CircleCheckIcon from '../icons/CircleCheckIcon'
import ErrorCircleRoundedIcon from '../icons/ErrorCircleRoundedIcon'
import InfoCircleOutlineIcon from '../icons/InfoCircleOutlineIcon'
import WarningIcon from '../icons/WarningIcon'

const BASE = 'tw:flex tw:items-center tw:gap-3 tw:p-3 tw:rounded-md! tw:text-sm'

const VARIANTS = {
  info: {
    box: 'tw:bg-ds-info-lowest tw:text-ds-neutral-highest',
    Icon: InfoCircleOutlineIcon,
    icon: 'tw:text-ds-info'
  },
  warning: {
    box: 'tw:bg-ds-warning-lowest tw:text-ds-warning',
    Icon: WarningIcon,
    icon: 'tw:text-ds-warning'
  },
  danger: {
    box: 'tw:bg-ds-danger-lowest tw:text-ds-danger',
    Icon: ErrorCircleRoundedIcon,
    icon: 'tw:text-ds-danger'
  },
  success: {
    box: 'tw:bg-ds-primary-lowest tw:text-ds-primary-highest',
    Icon: CircleCheckIcon,
    icon: 'tw:text-ds-primary'
  },
  neutral: {
    box: 'tw:bg-white tw:border tw:border-solid tw:border-gray-300 tw:p-4 tw:gap-4 tw:text-gray-600',
    Icon: InfoCircleOutlineIcon,
    icon: 'tw:text-gray-600'
  }
}

const Banner = ({ children, variant, className }) => {
  const { box, Icon, icon } = VARIANTS[variant]
  return (
    <div className={`${BASE} ${box} ${className}`.trim()} role="status">
      <Icon className={`tw:h-5 tw:w-5 tw:shrink-0 ${icon}`} />
      <div className="tw:min-w-0">{children}</div>
    </div>
  )
}

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['info', 'warning', 'danger', 'success', 'neutral'])
}

Banner.defaultProps = {
  className: '',
  variant: 'info'
}

export default Banner
